import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-compare-and-update-candidate-details-modal',
  templateUrl: './compare-and-update-candidate-details-modal.component.html'
})
export class CompareAndUpdateCandidateDetailsModalComponent implements OnInit {

  @Input() modalInstance: any;
  @Input() resolve: any;

  candidateConflictDetails: any;
  callbackObject: any;

  ngOnInit() {
    this.candidateConflictDetails = this.resolve.candidateConflictDetails;
    this.callbackObject = { callbackType: 'cancel', entity: {} };
  }

  saveCallback(contactDetails: any) {
    this.callbackObject = { callbackType: 'save', entity: contactDetails };
    this.closeModal();
  }

  closeModal() {
    this.modalInstance.close(this.callbackObject);
  }

  dismissModal() {
    this.modalInstance.dismiss('cancel');
  }
}
